export const whatsNew = {
  LearnMore: "Learn more",
  SeeAllUpdates: "See all updates",
  SeeWhatsNew: "See what's new",
  EnlargeCatalog: {
    title: "Improved direct-to-{{ patientTerm }} catalog",
    description: "Add {{ patientTerm }} resources directly from your new, visually-larger catalog.",
    FirstSection: {
      title: "Find and send {{ patientTerm }} resources alongside products",
      descriptionLine1:
        "<1>NEW!</1> Browse and attach {{ patientTerm }} resources to your plans right from the catalog in your plan-writing tool",
      descriptionLine2:
        "Upload your own or choose from 150+ free evidence-based handouts from Fullscript",
      descriptionLine3: "Your selection is made easier with a larger catalog view",
      highlight:
        "In a recent survey, 87% of {{ patientTermPlural }} said they find it easier to follow a supplement plan with relevant resources attached.",
      cta: "Done",
    },
  },
  AutoshipAndSave: {
    title: "Auto refills",
    description:
      "Make refills more affordable and generate ongoing practice revenue by offering {{ patientTermPlural }} a discount on auto refills.",
    FirstSection: {
      title: "Boost refills and revenue",
      descriptionLine1:
        "You can now offer {{ patientTermPlural }} an extra discount on all auto refills. This helps {{ patientTermPlural }} stay on track with plans that require ongoing dosages. Did you know that {{ patientTermPlural }} are up to 80% more likely to automate their refills when receiving an extra discount? Try it today!",
      footNote: "*Analysis of Fullscript {{ patientTermPlural }} (2023)",
      cta: "Set up auto refills discount",
    },
  },
  planIntent: {
    title: "Choose your preferred plan type",
    description: {
      firstLine: "We now offer three types of plans to help you achieve your goal:",
      bulletList: {
        first:
          "<individualPlans>Individual plans</individualPlans> focus on personalized one-to-one care.",
        second:
          "<multiPatientPlans>Multi-{{patientTerm}} plans</multiPatientPlans> allow you to create and share a plan with multiple {{patientTermPlural}}.",
        third:
          "<templates>Templates</templates> are reusable, shareable building blocks you can use to kick-start your individual or multi-{{patientTerm}} plans.",
      },
    },
    cta: "Done",
  },
  defaultCard: {
    title: "Check out what's new",
    description:
      "Explore new features, enhancements, and demo videos to help optimize your workflow.",
    cta: "Explore updates",
  },
} as const;
